// extracted by extract-css-chunks-webpack-plugin
module.exports = {"accentWrapper":"_1daoGu","articleLink":"QWzt_L","articleRow":"NA9Xfh","articleNumber":"_3hCoEv"};